module.exports = __webpack_public_path__ + "static/img/yycg_tan.b86db15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicClass/yycg_tan.png
// module id = PmY6
// module chunks = 23